module.exports = __webpack_public_path__ + "img/WIFI.d8b85993.png";